import script from "./accountInfoTemp.vue?vue&type=script&setup=true&lang=js"
export * from "./accountInfoTemp.vue?vue&type=script&setup=true&lang=js"

import "./accountInfoTemp.vue?vue&type=style&index=0&id=280fdf9a&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-280fdf9a"]])

export default __exports__